import * as React from 'react';

const Checkmark = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.86 18C9.583 18 9.318 17.883 9.13 17.68L4.27 12.51C3.892 12.107 3.912 11.473 4.315 11.095C4.718 10.717 5.352 10.737 5.73 11.14L9.85 15.53L18.26 6.33C18.606 5.9 19.235 5.83 19.666 6.176C20.096 6.522 20.166 7.152 19.819 7.582C19.795 7.613 19.769 7.642 19.74 7.67L10.6 17.67C10.413 17.877 10.149 17.997 9.87 18H9.86Z" fill="currentColor"/>
  </svg>
);

export default Checkmark;
